import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function SharedModal({ open, setOpen, title, content }) {
  return (
    <div>
      <Dialog open={open} onClose={setOpen} className="relative z-10">
        <DialogBackdrop />
        <div className="fixed inset-0 z-10">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel className="modal-tailwind">
              <div className="bg-white px-4 pt-4 pb-4 sm:p-6 sm:pb-4">
                <button
                  type="button"
                  onClick={() => setOpen(false)}
                  className="absolute top-3 right-3 inline-flex justify-end rounded-md text-sm font-semibold text-black"
                >
                  <XMarkIcon className="h-5 w-5 text-black" />
                </button>
                <DialogTitle>
                  <h3>{title}</h3>
                </DialogTitle>
                <div>{content}</div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
